<script>
    import { createEventDispatcher, onMount } from 'svelte';

	const dispatch = createEventDispatcher();
    let selected_node = null;

    onMount( () => {

        var buttons = document.getElementById("filter").getElementsByTagName("button");

        selected_node = buttons[0];
        selected_node.classList.add("active");    

    });

    const actionFilter = event => {

        var clickedElm = event.target;

        if( selected_node ) {
            if( selected_node == clickedElm ) {
                return;
            } else {
                selected_node.classList.remove("active");
            }
        }

        selected_node = clickedElm;
        selected_node.classList.add("active");

        dispatch('message', {
            text: clickedElm.getAttribute('data-filter')
        });

    };



</script>

<style>
    nav {
        margin: 1em 0;
    }

    ul {
        display: flex;
        border: 1px solid #fff;
        border-radius: 5px;
    }

    li {
        flex-basis: 33.33%;
        display: flex;
    }

    li:nth-of-type(2) {
        border-left: 1px solid #fff;
        border-right: 1px solid #fff;
    }

    button {
        width: 100%;
        padding: .5em;
        background: none;
        color: #fff;
        border: none;
        border-radius: 0;
        font-size: 14px;
        margin: 0;
    }

    :global(button.active) {
        background: #fff;
        color: var( --dark-color );
    }

</style>

<nav id="filter">
    <ul>
        <li><button  on:click={actionFilter} data-filter="all">All</button></li>
        <li><button  on:click={actionFilter} data-filter="food">Food</button></li>
        <li><button  on:click={actionFilter} data-filter="fc">Funeralcare</button></li>
    </ul>
</nav>